import { useMutation } from '@tanstack/react-query';
import { deleteDocument } from '../services/document-api/Documents';

interface DeleteDocumentVariables {
  beneId: number;
  documentId: string;
  caseId?: number;
}

export const useDeleteDocument = () => {
  return useMutation<void, Error, DeleteDocumentVariables>({
    mutationFn: async ({ beneId, documentId, caseId }: DeleteDocumentVariables) => {
      await deleteDocument(beneId, documentId, caseId);
      return;
    },
  });
};
